import device_type from "@/assets/data/device/device_type.json";

const deviceComp = () => import("@/views/omp/device/device.vue");

const deviceRoutes = device_type.map((item) => {
    const route = {
        path: `${item.key}`,
        name: `dev-device-${item.key}`,
        component: deviceComp,
        meta: {
            title: item.name,
            icon: `device_${item.key}`,
            typeId: item.id,
        },
    };
    return route;
});

export default [
    {
        path: "/dev",
        name: "dev__root__",
        redirect: {
            name: "dev-index",
        },
        component: () => import("@/layouts/default.vue"),
        meta: {
            parent: "dev",
            title: "",
        },
        children: [
            {
                path: "index",
                name: "dev-index",
                component: () => import("@/views/dev/index.vue"),
                meta: {
                    title: "控制面板",
                    icon: "index",
                    affix: true,
                },
            },
        ],
    },
    {
        path: "/dev/titan",
        name: "dev-titan",
        meta: {
            title: "全局设置",
            icon: "atom",
            parent: "dev",
            permission: "dev_manage_config",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/dev/titan/titanconf",
        children: [
            {
                path: "titanconf",
                name: "dev-titanconf",
                component: () => import("@/views/omp/titan/titanconf"),
                meta: {
                    title: "基础配置",
                    icon: "titanconf",
                    affix: false,
                },
            },
            {
                path: "timezoneconf",
                name: "dev-timezoneconf",
                component: () => import("@/views/omp/titan/timezone"),
                meta: {
                    title: "时区配置",
                    icon: "timezone",
                    affix: false,
                },
            },
            {
                path: "dashboard",
                name: "dashboard",
                component: () => import("@/views/cms/misc/dashboard"),
                meta: {
                    title: "导航配置",
                    icon: "application",
                    affix: false,
                },
            },
            {
                path: "permission",
                name: "dev-permission",
                component: () => import("@/views/omp/titan/permission"),
                meta: {
                    title: "权限配置",
                    icon: "lock",
                    affix: false,
                    permission: "dev_titan_permission",
                },
            },
        ],
    },
    {
        path: "/dev/device",
        name: "dev-device",
        meta: {
            title: "设备管理",
            icon: "device",
            parent: "dev",
            permission: "dev_manage_device",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: {
            name: "dev-device-list",
        },
        children: [
            {
                path: "list",
                name: "dev-device-list",
                component: () => import("@/views/omp/device/index.vue"),
                meta: {
                    title: "全部设备",
                    icon: "device2",
                },
            },
        ].concat(deviceRoutes),
    },
    {
        path: "/dev/sensor",
        name: "dev-sensor",
        meta: {
            title: "泰坦平台",
            icon: "sensor",
            parent: "dev",
            permission: "dev_manage_titan",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/dev/sensor/preset",
        children: [
            {
                path: "preset",
                name: "preset",
                component: () => import("@/views/omp/sensor/preset/index.vue"),
                meta: {
                    title: "属性预设",
                    icon: "preset",
                    affix: false,
                },
            },
            {
                path: "indicator",
                name: "indicator",
                component: () => import("@/views/omp/sensor/indicator"),
                meta: {
                    title: "环境指标",
                    icon: "eco",
                    affix: false,
                },
            },
            {
                path: "codesnippet",
                name: "codesnippet",
                component: () => import("@/views/omp/sensor/codesnippet"),
                meta: {
                    title: "代码片段",
                    icon: "codesnippet",
                    affix: false,
                },
            },
            {
                path: "nodetemplate",
                name: "nodetemplate",
                component: () => import("@/views/omp/sensor/nodetemplate"),
                meta: {
                    title: "节点模板",
                    icon: "nodetemplate",
                    affix: false,
                },
            },
            {
                path: "crontask",
                name: "crontask",
                component: () => import("@/views/omp/sensor/crontask"),
                meta: {
                    title: "定时任务",
                    icon: "crontask",
                    affix: false,
                },
            },
            {
                path: "irrigation",
                name: "irrigation",
                component: () => import("@/views/dev/titan/irrigation"),
                meta: {
                    title: "灌溉配置",
                    icon: "irrigation",
                    affix: false,
                    permission: "manage_sensor_irrigate",
                },
            },
        ],
    },
    {
        path: "/dev/mstpl",
        name: "mstpl",
        meta: {
            title: "消息模板",
            icon: "template",
            parent: "dev",
            permission: "dev_msg_template",
        },
        // hidden: true,
        component: () => import("@/layouts/default.vue"),
        redirect: "/dev/mstpl/email",
        children: [
            {
                path: "email",
                name: "mstplEmail",
                component: () => import("@/views/cms/mstpl/email.vue"),
                meta: {
                    title: "邮件模板",
                    icon: "template-email",
                    affix: false,
                },
            },
            {
                path: "email-detail/:slug([\\w_-]+)?",
                name: "mstplEmailDetail",
                hidden: true,
                component: () => import("@/views/cms/mstpl/email/detail.vue"),
                meta: {
                    title: "邮件模板详情",
                    affix: false,
                },
            },
        ],
    },
    {
        path: "/dev/account",
        name: "account",
        component: () => import("@/layouts/default.vue"),
        redirect: "/dev/account/list",
        meta: {
            title: "系统账号",
            icon: "admin",
            parent: "dev",
            permission: "dev_manage_account",
        },
        children: [
            {
                path: "list",
                name: "account-list",
                component: () => import("@/views/dev/account/list.vue"),
                meta: {
                    title: "账户管理",
                    icon: "users",
                    app: "cms",
                },
            },
            {
                path: "permission",
                name: "account-permission",
                component: () => import("@/views/dev/account/permission.vue"),
                meta: {
                    title: "权限配置",
                    icon: "group",
                    group: 512,
                },
            },
        ],
    },
    {
        path: "/dev/system",
        name: "dev-system",
        meta: {
            title: "系统管理",
            icon: "system",
            parent: "dev",
            permission: "dev_manage_system",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: {
            name: "dev-system-app",
        },
        children: [
            {
                path: "app",
                name: "dev-system-app",
                component: () => import("@/views/dev/system/app/index.vue"),
                meta: {
                    title: "应用管理",
                    icon: "application",
                    affix: false,
                },
            },
            {
                path: "cache",
                name: "dev-system-cache",
                component: () => import("@/views/dev/system/cache.vue"),
                meta: {
                    title: "缓存管理",
                    icon: "redis",
                    affix: false,
                },
            },
            {
                path: "deploy",
                name: "dev-system-deploy",
                component: () => import("@/views/dev/system/deploy.vue"),
                meta: {
                    title: "前端部署",
                    icon: "redis",
                    affix: false,
                },
            },
        ],
    },
    {
        path: "/dev/log",
        name: "dev-log",
        meta: {
            title: "系统日志",
            icon: "system",
            parent: "dev",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: {
            name: "dev-system-app",
        },
        children: [
            {
                path: "upload-log",
                name: "cms-upload-log",
                component: () => import("@/views/dev/system/upload_log.vue"),
                meta: {
                    title: "上传日志",
                    icon: "upload",
                    permission: "manage_system_upload_log_cms",
                },
            },
            {
                path: "service-log",
                name: "cms-service-log",
                component: () => import("@/views/dev/system/service_log/index.vue"),
                meta: {
                    title: "后端日志",
                    icon: "terminal",
                    permission: "manage_system_service_log_cms",
                },
            },
        ],
    },
];
